import React from 'react';

import { SiteAnalyticsPageLoader } from '@confluence/confluence-analytics/entry-points/SiteAnalyticsPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const SiteAnalyticsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { tab } }: RouteMatch): {
		Screen: {
			// screenEvent will be handled in the page components
			pageState: {
				routeName: string;
				tab: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	return <SiteAnalyticsPageLoader />;
};

SiteAnalyticsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { tab },
}: RouteMatch): {
	Screen: {
		// screenEvent will be handled in the page components
		pageState: {
			routeName: string;
			tab: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => {
	return {
		Screen: {
			// screenEvent will be handled in the page components
			pageState: {
				routeName: name,
				tab,
			},
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
